import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { legalDocuments, type LegalDocument } from '../data/legal';
export function Footer() {
  const [openDoc, setOpenDoc] = useState<LegalDocument | null>(null);
  return <footer className="bg-cream" data-id="element-56" data-mp="32pfeg99kbdx4">
      <div className="mx-auto max-w-5xl px-6 py-12" data-id="element-57" data-mp="32m1et8sa9itd">
        <div className="border-t border-ink/10 pt-8" data-id="element-58" data-mp="36q92r3qx2uqj">
          <div className="flex flex-col gap-6 sm:flex-row sm:items-center sm:justify-between" data-id="element-59" data-mp="3uf0md6qfy4rp">
            <p className="font-display text-base font-semibold text-ink" data-id="element-60" data-mp="38qtqszerhoj">
              Método Vientre Plano 21D
            </p>
            <nav aria-label="Información legal" data-id="element-61" data-mp="3lf57orxofrmx">
              <ul className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-62" data-mp="3lggbgrr4gze1">
                {legalDocuments.map(doc => <li key={doc.id} data-id="element-63" data-mp="29zgli2s8ywn6">
                    <button type="button" onClick={() => setOpenDoc(doc)} className="rounded text-sm text-ink/60 underline decoration-ink/20 underline-offset-4 transition-colors duration-150 ease-smooth hover:text-teal hover:decoration-teal focus:outline-none focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-64" data-mp="29yduzvyu6w7s">
                      {doc.label}
                    </button>
                  </li>)}
              </ul>
            </nav>
          </div>

          <p className="mt-8 max-w-2xl text-xs leading-relaxed text-ink/50" data-id="element-65" data-mp="81foxu0vmo35">
            Este material es de carácter educativo y no reemplaza una consulta
            médica. Si tienes una condición diagnosticada, consulta con tu
            profesional de salud antes de iniciar el protocolo.
          </p>
          <p className="mt-4 text-xs text-ink/40" data-id="element-66" data-mp="cuil89x1gbn1">
            © {new Date().getFullYear()} Método Vientre Plano 21D. Todos los
            derechos reservados.
          </p>
        </div>
      </div>

      <LegalModal document={openDoc} onClose={() => setOpenDoc(null)} data-id="element-67" data-mp="mtrbaros9644" />
    </footer>;
}